var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"memberbrief d-flex flex-column align-items-start"},[_c('h4',{staticClass:"mt-3"},[_vm._v(_vm._s(this.member_data.name))]),_c('p',[_vm._v(_vm._s(this.member_data.position))])])}
var staticRenderFns = []

export { render, staticRenderFns }